import { useEffect, useState } from "react";
// Importamos o Device do Capacitor para info nativa
import { Device } from '@capacitor/device';
import { navigateTo } from '../../navigate';
import { Link } from 'react-router-dom';

// Transformamos em async para suportar as promessas do Capacitor
export async function getDeviceInfo() {
  const ua = navigator.userAgent.toLowerCase();

  const isWindows = ua.includes("windows");
  const isMac = ua.includes("mac os");
  const isLinux = ua.includes("linux") && !ua.includes("android");
  const isAndroid = ua.includes("android");
  const isIOS = /iphone|ipad|ipod/.test(ua);

  const isMobile = /mobile|android|iphone|ipad|ipod/.test(ua);
  const type = isMobile ? "Celular/Tablet" : "Computador";
  
  // Lógica original de Fallback para Web
  const matchModel = ua.match(/\((?:linux; android [^;]+; )([^;)]+)/);
  let model = matchModel ? matchModel[1] : ``;
  
  let sistema = '';
  if (isAndroid) {
    const match = ua.match(/android\s([\d._]+)/);
    sistema = match ? `Android ${match[1]}` : 'Android';
  } else if (isIOS) {
    const match = ua.match(/os\s([\d_]+)/);
    sistema = match ? `iOS ${match[1].replace(/_/g, '.')}` : 'iOS';
  }

  // --- INÍCIO DA CAPTURA NATIVA (CAPACITOR) ---
  const isNative = !!(typeof window !== 'undefined' && window.Capacitor && window.Capacitor.isNativePlatform());

  let infoNativa = {};
  
  if (isNative) {
    try {
      const info = await Device.getInfo();
      const id = await Device.getId();
      infoNativa = {
        sistema: `${info.operatingSystem} ${info.osVersion}`,
        modelo: `${info.manufacturer} ${info.model}`,
        plataforma: info.platform,
        uuid: id.identifier
      };
    } catch (e) {
      console.error("Erro ao pegar info nativa", e);
    }
  }
  // --- FIM DA CAPTURA NATIVA ---

  return {
    tipo: type,
    sistema: infoNativa.sistema || (isWindows
      ? "Windows"
      : isMac
      ? "macOS"
      : isLinux
      ? "Linux"
      : isAndroid
      ? sistema || "Android"
      : isIOS
      ? sistema || "iOS"
      : ""),
    modelo: infoNativa.modelo || model,
    agente: navigator.userAgent,
    plataforma: infoNativa.plataforma || navigator.platform || "",
    idioma: navigator.language || "",
    cpu_cores: navigator.hardwareConcurrency || "",
    memoria: navigator.deviceMemory
      ? `${navigator.deviceMemory} GB`
      : "",
    conexao: navigator.onLine ? "Conectado" : "Offline",
    resolucao: `${window.screen.width}x${window.screen.height}`,
    profundidadeCor: `${window.screen.colorDepth} bits`,
    // Adicionado UUID apenas se for nativo
    ...(infoNativa.uuid && { uuid: infoNativa.uuid })
  };
}

// Componente padrão que usa os dados
export default function DeviceInfo() {
  const [info, setInfo] = useState({});

  useEffect(() => {
    // Chamada assíncrona para getDeviceInfo
    const carregarInfo = async () => {
      const dados = await getDeviceInfo();
      setInfo(dados);
    };
    carregarInfo();
  }, []);

  return (
    <div style={{ padding: 20 }}>
      <h3>Informações do dispositivo</h3>
      <ul>
        {Object.entries(info).map(([key, value]) => (
          <li key={key}>
            <strong>{key}:</strong> {value}
          </li>
        ))}
      </ul>
      <Link
        to={`/logout/all`}
        className="btn btn-outline-secondary w-100 text-center btn text-decoration-none"
      >
        Sair em todos dispositivos conectados
      </Link>
    </div>
  );
}
